import { useMutation, useQuery, useQueryClient } from "react-query";

import toast from "react-hot-toast";
import { ChargePointService } from "./charge-point.service";

// GET List
const useGetList = (page: number, option?: Object, enabled?: boolean) => {
  return useQuery(
    ["list_chargepoints", page, option],
    async () => {
      const { data } = await ChargePointService.getListChargePoint({
        page,
        ...option,
      });
      return data;
    },
    { keepPreviousData: true, enabled: enabled }
  );
};

// GET Detail
const useGetDetail = (id?: string) => {
  return useQuery(
    ["getDetail", id],
    async () => {
      const { data } = await ChargePointService.getDetailChargePoint(id);
      return data;
    },
    { enabled: id ? true : false }
  );
};

const useGetListRestricted = (page: number, option?: Object) => {
  return useQuery(
    ["listUserRestricted", page, option],
    async () => {
      const { data } = await ChargePointService.getListRestrictedUser({
        page,
        ...option,
      });
      return data;
    },
    { keepPreviousData: true }
  );
};

const useEnableSubscriptionPlans = (cb?: (data: any) => void) => {
  return useMutation(
    async (createItem: any) => {
      const data = await ChargePointService.enableSubscriptionPlans(createItem);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Create successfully!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error, _variables, _context) {
        alert(error);
      },
    }
  );
};

const useCreateChargePoint = (callback?: (data: any) => void) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      const data = await ChargePointService.createChargePoint(payload);
      return data;
    },
    {
      onSuccess: (data) => {
        callback?.(data);
        if (data.ok) {
          toast.success("Create Charge Point Success!");
          queryClient.invalidateQueries(["list_chargepoints"]);
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error: any) {
        toast.error(error?.msg);
        return error;
      },
    }
  );
};

const useUpdateChargePoint = (callback?: (data: any) => void) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      const data = await ChargePointService.updateChargePoint(payload);
      return data;
    },
    {
      onSuccess: (data) => {
        callback?.(data);
        if (data.ok) {
          toast.success("Update Charge Point Success!");
          queryClient.invalidateQueries(["list_chargepoints"]);
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error: any) {
        toast.error(error?.msg);
        return error;
      },
    }
  );
};

export {
  useCreateChargePoint,
  useEnableSubscriptionPlans,
  useGetDetail,
  useGetList,
  useGetListRestricted,
  useUpdateChargePoint,
};
